// Module
var code = ` <div class="row"> <div class="col-sm-4 stacked-spacing-col-sm"> <crs-datetimepicker model="answer.value" month-year-only="true" input-id="block-input-{{block.id}}"> </crs-datetimepicker> </div> </div> `;
// Exports
var _module_exports =code;;
var path = '/views/blocks/graduationDateQuestion.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;